<template>
  <LandingPageBLG />
</template>

<script>
import LandingPageBLG from "./LandingPageBLG.vue";

export default {
  components: {
    LandingPageBLG,
  },
};
</script>
